/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import '../../shared/arial';
import Loader from 'react-loader-spinner';
import MaterialTable from 'material-table';
import { makeStyles } from '@material-ui/core/styles';
import {
  Loading,
  exportXlsx,
  numGradeToEUgrade,
} from '../../helpers/utils';
import examType6Services from '../../redux/services/examType6Services';
import ExamResultsDetails from './ExamResultsDetails';
import 'jspdf-autotable';
// import DownloadQuizsDetails from './DownloadQuizsDetails';
// import DownloadQuizCorrection from './DownloadQuizCorrection';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    marginBottom: 20,
  },
  resultRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '10px',
  },
  gradeDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  totalGrade: {
    // color: '#000000',
    fontSize: '13px',
    fontWeight: 'bold',
  },
  resultDetail: {
    // color: '#666666',
    fontSize: '13px',
  },
}));

const ExamResultsTypePlacementTest = ({
  grpLvl1,
  grpLvl2,
  semester,
  examIdentifier,
  // examModalities,
}) => {
  const [loadingState, setLoadingState] = useState(false);
  const [substring, setSubstring] = useState(null);
  const [open, setOpen] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [group, setGroup] = useState({});
  // const [exam, setExam] = useState({});
  const [examId, setExamId] = useState();
  const [totalPapers, setTotalPapers] = useState(0);
  const refTable = useRef();

  const [examData, setExamData] = useState([]);

  const classes = useStyles();

  const columns = [
    {
      title: 'Firstname',
      field: 'firstname',
    },
    {
      title: 'Name',
      field: 'name',
      defaultSort: 'asc',
    },
    {
      title: 'Score',
      field: 'grade',
      render: (rowData) => (
        <Typography variant="caption">{numGradeToEUgrade(rowData?.grade?.total) || 'n/a'}</Typography>
      ),
    },
    {
      title: 'Problem',
      field: 'fetched',
    },
  ];

  const loadExamResults = async () => {
    const formatedArray = [];
    let papers = 0;
    setLoadingState(true);
    if (grpLvl1 && semester && examIdentifier) {
      try {
        const resGrp1 = await examType6Services.getPlacementTestResultsByGroup(
          grpLvl1,
          semester,
          examIdentifier,
        );
        if (resGrp1 && resGrp1.listIdUsers && resGrp1.listIdUsers.length > 0) {
          setGroup(resGrp1);
          resGrp1.listIdUsers.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(semester, 10)
              || (student.catchUp && student.catchUp?.includes(parseFloat(semester, 10)))) {
              if (student.grade) {
                papers += 1;
                formatedArray.push({
                  testId: student.testId,
                  userId: student._id,
                  grade: student.grade,
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp1._id,
                  fetched: 'No problem',
                });
              } else {
                formatedArray.push({
                  userId: student._id,
                  grade: 0,
                  state: 'Échoué',
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp1._id,
                  fetched: 'No score',
                });
              }
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
    if (grpLvl2 && semester && examIdentifier) {
      try {
        const resGrp2 = await examType6Services.getPlacementTestResultsByGroup(
          grpLvl2,
          semester,
          examIdentifier,
        );
        if (resGrp2 && resGrp2.listIdUsers && resGrp2.listIdUsers.length > 0) {
          resGrp2.listIdUsers.forEach((student) => {
            if (parseFloat(student.semester, 10) === parseFloat(semester, 10)
              || parseFloat(student.semester, 10) - 1 === parseFloat(semester, 10)
              || (student.catchUp && student.catchUp?.includes(parseFloat(semester, 10)))) {
              if (student.grade) {
                papers += 1;
                formatedArray.push({
                  testId: student.testId,
                  userId: student._id,
                  grade: student.grade,
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp2._id,
                  fetched: 'No problem',
                });
              } else {
                formatedArray.push({
                  userId: student._id,
                  grade: 0,
                  state: 'Échoué',
                  firstname: student.firstname,
                  name: student.name,
                  groupId: resGrp2._id,
                  fetched: 'No score',
                });
              }
            }
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
    setTotalPapers(papers);
    setExamData(formatedArray);
    setLoadingState(false);
  };

  useEffect(() => {
    loadExamResults();
  }, [semester, examIdentifier, grpLvl1, grpLvl2]);

  const handleRedirect = () => {
    setRedirect(true);
  };

  if (redirect) {
    return <Redirect to="/list" />;
  }
  return (
    <div className={classes.root}>
      <Container className="dashboard">
        <Row>
          <Col md={1} style={{ marginBottom: '20px' }}>
            <IconButton
              aria-label="delete"
              onClick={() => handleRedirect()}
            >
              <ArrowBackIcon />
            </IconButton>
          </Col>
        </Row>
      </Container>
      <Grid container spacing={2}>
        {/* {(examData && examData.length > 0) && <DownloadQuizCorrection examData={examData} />}
        {(examData && examData.length > 0) && <DownloadQuizsDetails examData={examData} />} */}
        <Grid item xs={12} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {
            examData && examData.length > 0
              ? (
                <MaterialTable
                  style={{ width: '100%' }}
                  title={`Results for ${group.name.replace(/\b(level 1|level 2)\b\s*$/i, '')} - Total papers: ${totalPapers}`}
                  columns={columns}
                  isLoading={loadingState}
                  components={{
                    OverlayLoading: () => (<Loading />),
                  }}
                  localization={{
                    body: {
                      emptyDataSourceMessage: loadingState ? '' : 'No records to display',
                    },
                  }}
                  tableRef={refTable}
                  data={examData}
                  options={{
                    search: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportCsv: () => {
                      const finalResults = [];
                      const resultsArr = [...examData];
                      resultsArr.sort((a, b) => a.name > b.name);
                      resultsArr.forEach((elem) => {
                        const item = {};
                        item.Nom = elem.name;
                        item['Prénom'] = elem.firstname;
                        item.Score = numGradeToEUgrade(elem?.grade?.total || 0);
                        finalResults.push(item);
                      });
                      const today = new Date();
                      const sortedArr = finalResults.sort((a, b) => ((
                        a.Nom > b.Nom)
                        ? 1
                        : ((b.Nom > a.Nom)
                          ? -1
                          : 0)
                      ));
                      exportXlsx(sortedArr, `${group.name.replace(/\b(level 1|level 2)\b\s*$/i, '')}_${today.getDate()}/${today.getMonth() + 1}`);
                    },
                    exportAllData: true,
                    pageSize: examData.length,
                    sorting: true,
                    tableLayout: 'auto',
                  }}
                  onRowClick={(e, data) => {
                    if (substring !== data.userId) {
                      setSubstring(data.userId);
                    } else {
                      setSubstring(null);
                    }
                  }}
                />
              )
              : <Loader type="TailSpin" color="#3F51B5" height={40} width={40} />
          }
          {examId && examId !== null
            && (
            <ExamResultsDetails
              examId={examId}
              setExamId={setExamId}
              open={open}
              setOpen={setOpen}
            />
            )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ExamResultsTypePlacementTest;
